import React, { useEffect, useRef, useState } from "react";
import { useTokenInfoStats } from "../hooks/useTokenInfo";
import { useSidebar } from "../context/useSidebar";
import CoinDetail from "./CoinDetail";
import Carasoul from "./Carasoul/Carousel";
/* global ApexCharts,Swiper */

export default function Home() {
  const stats = useTokenInfoStats(1);
  const { isSidebarOpen, isRightSidebarOpen } = useSidebar();
  const count = useRef(0);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  let buytax = () => {
    try {
      var options = {
        series: [stats.totalBuyTax],
        chart: {
          width: 180,
          height: 180,
          type: "radialBar",
        },
        colors: ["#1EBA62"],
        plotOptions: {
          radialBar: {
            startAngle: -180,
            endAngle: 120,
            hollow: {
              size: "60%",
              background: "rgba(1, 163, 255, 0.1)",
              margin: 15,
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: 20,
                show: true,
                color: "#888",
                fontSize: "12px",
              },
              value: {
                formatter: function (val) {
                  return 5 + "%";
                },
                offsetY: -10,
                color: "#1EBA62",
                fontWeight: 700,
                fontSize: "18px",
                show: true,
              },
            },
            track: {
              background: "#737b8b",
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: [""],
        responsive: [
          {
            breakpoint: 575,
            options: {
              chart: {
                height: 200,
              },
            },
          },
        ],
      };
      var chart = new ApexCharts(document.querySelector("#buytax"), options);
      chart.render();
    } catch (err) {
      console.log(err.message);
    }
  };

  let selltax = () => {
    try {
      var options = {
        series: [stats.totalSellTax],
        chart: {
          width: 180,
          height: 180,
          type: "radialBar",
        },
        colors: ["#dc3545"],
        plotOptions: {
          radialBar: {
            startAngle: -180,
            endAngle: 120,
            hollow: {
              size: "60%",
              background: "rgba(1, 163, 255, 0.1)",
              margin: 15,
            },
            dataLabels: {
              show: true,
              name: {
                offsetY: 20,
                show: true,
                color: "#888",
                fontSize: "12px",
              },
              value: {
                formatter: function (val) {
                  return 5 + "%";
                },
                offsetY: -10,
                color: "#dc3545",
                fontWeight: 700,
                fontSize: "18px",
                show: true,
              },
            },
            track: {
              background: "#737b8b",
            },
          },
        },
        stroke: {
          lineCap: "round",
        },
        labels: [""],
        responsive: [
          {
            breakpoint: 575,
            options: {
              chart: {
                height: 200,
              },
            },
          },
        ],
      };
      var chart = new ApexCharts(document.querySelector("#selltax"), options);

      chart.render();
    } catch (err) {
      console.log(err.message);
    }
  };

  var pieChart = function () {
    var options = {
      labels: ["Pre-Sales (ICO)", "Ecosystem", "Community", "Team", "Marketing", "Liquidity Pools", "Burn"],
      series: [30, 30, 5, 5, 10, 10, 10],
      chart: {
        type: "donut",
        height: 200,
        innerRadius: 50,
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 0,
      },
      plotOptions: {
        pie: {
          startAngle: 0,
          endAngle: 360,
          donut: {
            size: "80%",
          },
        },
      },
      colors: ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0", "#546E7A", "#26a69a"],
      legend: {
        position: "bottom",
        show: false,
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: {
              width: 200,
            },
          },
        },
      ],
    };

    var chart = new ApexCharts(document.querySelector("#pieChart"), options);

    chart.render();
  };

  var swipercard = function () {
    new Swiper(".mySwiper-counter", {
      speed: 1500,
      slidesPerView: 4,
      spaceBetween: 40,
      parallax: true,
      loop: false,
      autoplay: {
        delay: 5000,
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        576: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
    });
  };

  var swiperreview = function () {
    new Swiper(".mySwiper", {
      slidesPerView: 1,
      speed: 1500,
      spaceBetween: 40,
      loop: false,

      autoplay: {
        delay: 5000,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        991: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
      },
    });
  };

  function activity() {
    var optionsArea = {
      series: [
        {
          name: "Persent",
          data: [60, 70, 80, 50, 60, 90],
        },
        {
          name: "Visitors",
          data: [40, 50, 40, 60, 90, 90],
        },
      ],
      chart: {
        height: 300,
        type: "area",
        group: "social",
        toolbar: {
          show: false,
        },
        zoom: {
          enabled: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: [3, 3, 3],
        colors: ["var(--secondary)", "var(--primary)"],
        curve: "straight",
      },
      legend: {
        show: false,
        tooltipHoverFormatter: function (val, opts) {
          return val + " - " + opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] + "";
        },
        markers: {
          fillColors: ["var(--secondary)", "var(--primary)"],
          width: 10,
          height: 10,
          strokeWidth: 0,
          radius: 16,
        },
      },
      markers: {
        size: [8, 8],
        strokeWidth: [4, 4],
        strokeColors: ["var(--secondary)", "var(--primary)"],
        border: 2,
        radius: 2,
        colors: ["#fff", "#fff", "#fff"],
        hover: {
          size: 10,
        },
      },
      xaxis: {
        categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        labels: {
          style: {
            colors: "var(--text)",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: 100,
          },
        },
        axisBorder: {
          show: false,
        },
      },
      yaxis: {
        labels: {
          minWidth: 20,
          offsetX: -16,
          style: {
            colors: "var(--text)",
            fontSize: "14px",
            fontFamily: "Poppins",
            fontWeight: 100,
          },
        },
      },
      fill: {
        colors: ["#fff", "#fff"],
        type: "gradient",
        opacity: 1,
        gradient: {
          shade: "light",
          shadeIntensity: 1,
          colorStops: [
            [
              {
                offset: 0,
                color: "#fff",
                opacity: 0,
              },
              {
                offset: 0.6,
                color: "#fff",
                opacity: 0,
              },
              {
                offset: 100,
                color: "#fff",
                opacity: 0,
              },
            ],
            [
              {
                offset: 0,
                color: "#fff",
                opacity: 0.4,
              },
              {
                offset: 50,
                color: "#fff",
                opacity: 0.25,
              },
              {
                offset: 100,
                color: "#fff",
                opacity: 0,
              },
            ],
          ],
        },
      },
      colors: ["#1EA7C5", "#FF9432"],
      grid: {
        borderColor: "var(--border)",
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
      },

      responsive: [
        {
          breakpoint: 1602,
          options: {
            markers: {
              size: [6, 6, 4],
              hover: {
                size: 7,
              },
            },
            chart: {
              height: 230,
            },
          },
        },
      ],
    };

    if (document.querySelector("#activity")) {
      var dzchart = new ApexCharts(document.querySelector("#activity"), optionsArea);

      dzchart.render();

      document.querySelector("#dzOldSeries").addEventListener("change", function () {
        this.classList.toggle("disabled");
        dzchart.toggleSeries("Persent");
      });

      document.querySelector("#dzNewSeries").addEventListener("change", function () {
        this.classList.toggle("disabled");
        dzchart.toggleSeries("Visitors");
      });
    }
  }

  useEffect(() => {
    if (count.current === 0 && !stats.loading) {
      count.current += 1;

      swipercard();
      swiperreview();
      activity();
    } else if (count.current === 0 && stats.loading) {
      count.current += 1;
      buytax();
      selltax();
      pieChart();
      swiperreview();
      activity();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stats]);

  return (
    <>
      <div
        className={`content-body default-height bg-primary-gradient ${isSidebarOpen ? "sidebar-open-page-margin" : "sidebar-close-page-margin"}`}
        style={{
          paddingRight: screenWidth > 1700 && isRightSidebarOpen ? "26.75rem" : "0",
        }}
      >
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-12">
              <div className="row">
                <div className="col-xl-12">
                  <div className="page-titles">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                          <a href="#sec">Dashboard</a>
                        </li>
                        <li className="breadcrumb-item active" aria-current="page">
                          Dashboard
                        </li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12 wow fadeInUp" data-wow-delay="1.5s">
                  <div className="swiper mySwiper-counter position-relative overflow-hidden">
                    <Carasoul stats={stats} />
                  </div>
                </div>
                <div className="col-xl-8 wow fadeInUp" data-wow-delay="1.5s">
                  <div className="card crypto-chart">
                    <div className="card-header pb-0 border-0 flex-wrap">
                      <div className="mb-2 mb-sm-0">
                        <div className="chart-title mb-3">
                          <h2 className="card-title">Token Chart</h2>
                        </div>
                      </div>
                    </div>
                    <div className="card-body pt-2 custome-tooltip pb-0">
                      <iframe
                        className="dexscreen-card"
                        title="GLDN Chart"
                        src="https://www.dextools.io/widget-chart/en/ether/pe-light/0x0d4a11d5eeaac28ec3f61d100daf4d40471f1852?theme=dark&amp;chartType=0&amp;chartResolution=30&amp;drawingToolbars=true"
                        style={{ height: "430px", width: "100%", borderRadius: "22px" }}
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div className="col-xl-4 wow fadeInUp" data-wow-delay="1s">
                  <div className="card">
                    <div className="card-header border-0">
                      <h2 className="card-title">Token Allocation </h2>
                    </div>
                    <div className="card-body text-center pt-0 pb-2">
                      <div id="pieChart" className="d-inline-block"></div>
                      <div className="chart-items">
                        <div className="row">
                          <div className=" col-xl-12 col-sm-12">
                            <div className="text-start mt-2">
                              <h6>Legend</h6>
                              <div className="color-picker">
                                <p className="mb-0  text-gray">
                                  <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="4" fill="#008FFB" />
                                  </svg>
                                  Pre-Sales (ICO) (30%)
                                </p>
                              </div>
                              <div className="color-picker">
                                <p className="mb-0 text-gray">
                                  <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="4" fill="#00E396" />
                                  </svg>
                                  Ecosystem (30%)
                                </p>
                              </div>
                              <div className="color-picker">
                                <p className="mb-0 text-gray">
                                  <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="4" fill="#FEB019" />
                                  </svg>
                                  Community (5%)
                                </p>
                              </div>
                              <div className="color-picker">
                                <p className="mb-0 text-gray">
                                  <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="4" fill="#FF4560" />
                                  </svg>
                                  Team (5%)
                                </p>
                              </div>
                              <div className="color-picker">
                                <p className="mb-0 text-gray">
                                  <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect width="14" height="14" rx="4" fill="#775DD0" />
                                  </svg>
                                  Marketing (10%)
                                </p>
                              </div>
                              {/* <div className="color-picker">
                                    <p className="mb-0 text-gray">
                                      <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="14" height="14" rx="4" fill="#546E7A" />
                                      </svg>
                                      Liquidity Pools (10%)
                                    </p>

                                  </div>
                                  <div className="color-picker">
                                    <p className="mb-0 text-gray">
                                      <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect width="14" height="14" rx="4" fill="#26a69a" />
                                      </svg>
                                      Burn (10%)
                                    </p>

                                  </div> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 wow fadeInUp" data-wow-delay="1s">
                  <CoinDetail />
                </div>
                <div className="col-xl-6">
                  <div className="col-xl-12">
                    <div className="card Upgrade">
                      <div className="card-body d-flex align-items-center ps-0">
                        <div className="d-inline-block position-relative donut-chart-sale ">
                          <div id="buytax"></div>
                        </div>
                        <div className="upgread-stroage text-white">
                          <h4>BUY TAX</h4>
                          <p className="text-white">Buy taxes on trade from dex</p>
                          <button type="button" className="btn btn-success btn-sm light">
                            On Buy {stats.totalBuyTax}% Tax will charge.
                          </button>
                          <div className="color-picker mt-3">
                            <p className="mb-0  text-white">
                              <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="14" height="14" rx="4" fill="#008FFB" />
                              </svg>
                              Marketing / Development (2%)
                            </p>
                          </div>
                          <div className="color-picker">
                            <p className="mb-0 text-white">
                              <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="14" height="14" rx="4" fill="#00E396" />
                              </svg>
                              Auto Liquidity (1%)
                            </p>
                          </div>
                          <div className="color-picker">
                            <p className="mb-0 text-white">
                              <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="14" height="14" rx="4" fill="#FEB019" />
                              </svg>
                              Reward (2%)
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xl-12 text-white">
                    <div className="card Upgrade">
                      <div className="card-body d-flex align-items-center ps-0">
                        <div className="d-inline-block position-relative donut-chart-sale ">
                          <div id="selltax"></div>
                        </div>
                        <div className="upgread-stroage">
                          <h4 className="text-danger">Sell TAX</h4>
                          <p className="text-white">Sell taxes on trade from dex</p>
                          <button type="button" className="btn btn-danger btn-sm light">
                            On Sell {stats.totalSellTax}% Tax will charge.
                          </button>
                          <div className="color-picker mt-3">
                            <p className="mb-0  text-white">
                              <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="14" height="14" rx="4" fill="#008FFB" />
                              </svg>
                              Marketing / Development (2%)
                            </p>
                          </div>
                          <div className="color-picker">
                            <p className="mb-0 text-white">
                              <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="14" height="14" rx="4" fill="#00E396" />
                              </svg>
                              Auto Liquidity (1%)
                            </p>
                          </div>
                          <div className="color-picker">
                            <p className="mb-0 text-white">
                              <svg className="me-2" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <rect width="14" height="14" rx="4" fill="#FEB019" />
                              </svg>
                              Reward (2%)
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
